@if (yearbookHref()) {
  <div class="yearbook-banner-container">
    <div class="yearbook-header">
      <div class="yearbook-icon">
        <lt-icon name="fa-regular-book-heart"></lt-icon>
      </div>

      <div class="yearbook-message">
        <span>{{ 'YEARBOOK_AVAILABLE_MESSAGE' | ltTranslate }} </span>
      </div>
    </div>

    <div class="yearbook-action">
      <a class="btn lt-btn-secondary" [href]="yearbookHref()" target="_blank">
        <span>{{ 'ORDER_NOW_BUTTON_TEXT' | ltTranslate }}</span>
      </a>
    </div>
  </div>
}
